import { IndicatorBadge } from '@carvana/helios-decoration/badge';
import { Card, breakpoint } from '@carvana/helios-layout';
import { background, body, borderRadius, label, spacing, text } from '@carvana/helios-styles';
import { Link } from '@carvana/helios-navigation';
import styled from 'styled-components';
import { heading } from '@carvana/helios-typography';

type Priority = 'critical' | 'warning' | 'informational';
export const BadgeWrapper = styled.div<{ priority: Priority }>`
  display: flex;
  align-items: center;
  padding: 2px 0;
  color: ${props => text[props.priority]};
  ${label.sm}
`;

const CardWrapper = styled(Card)`
  width: 300px;
  color: ${text.strong};
  margin: 8px 0;
  ${breakpoint.sm`
    margin: 0;
  `}
  ${breakpoint.md`
    width: 408px;
  `}
`;

export const StyledIndicatorBadge = styled(IndicatorBadge)`
  margin-right: 6.5px;
`;

const ContentWrapper = styled.div`
  height: 86px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const SkeletonImageWrap = styled.div`
  margin: 16px 10px 16px 16px;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;

const ImageWrap = styled.div`
  position: relative;
  height: 110px;
  max-width: 79px;
  background-color: ${background.weak};
  border-radius: ${borderRadius.sm};
`;

const VehicleValue = styled.span`
  ${heading.md};
  margin-right: ${spacing.sm};
`;

const ExpiredText = styled.span`
  ${body.regular.xs};
`;

const YearMake = styled.div`
  ${heading.xs};
  margin: 8px 0;
`;

export {
  CardWrapper,
  ContentWrapper,
  SkeletonImageWrap,
  ImageWrap,
  VehicleValue,
  ExpiredText,
  YearMake
};
